import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';
import getApiBase from '../utils/apiBase';
import './AdminProducts.css';
import './AdminCommunity.css';

const API_BASE = getApiBase();

const AdminCommunity = () => {
  const [auth, setAuth] = useState(localStorage.getItem('adminAuth') || '');
  const [login, setLogin] = useState({ username: '', password: '' });
  const [reports, setReports] = useState([]);
  const [status, setStatus] = useState('');

  const headers = auth ? { Authorization: `Basic ${auth}` } : {};
  const loadReports = useCallback(async () => {
    if (!auth) return;
    const response = await fetch(`${API_BASE}/api/admin/community/reports?status=all`, {
      credentials: 'include',
      headers: auth ? { Authorization: `Basic ${auth}` } : {},
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      setStatus(data.error || 'Unable to load reports.');
      return;
    }
    setReports(data.items || []);
  }, [auth]);

  useEffect(() => { loadReports(); }, [loadReports]);

  const loginAdmin = (event) => {
    event.preventDefault();
    const token = btoa(`${login.username}:${login.password}`);
    localStorage.setItem('adminAuth', token);
    setAuth(token);
  };

  const write = async (path, body) => {
    const response = await fetch(`${API_BASE}${path}`, {
      method: 'PATCH', credentials: 'include', headers: { ...headers, 'Content-Type': 'application/json' }, body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.error || 'Moderation request failed.');
  };

  const moderate = async (report, action) => {
    try {
      await write(`/api/admin/community/content/${report.target_type}/${report.target_id}`, { action });
      setStatus(`Content ${action === 'hide' ? 'hidden' : 'restored'}.`);
      await loadReports();
    } catch (error) { setStatus(error.message); }
  };

  const resolve = async (report, nextStatus) => {
    try {
      await write(`/api/admin/community/reports/${report.id}`, { status: nextStatus });
      await loadReports();
    } catch (error) { setStatus(error.message); }
  };

  if (!auth) return (
    <main className="admin-products"><Seo title="Community Moderation" path="/admin/community" noindex /><header className="admin-header"><h1>Community Moderation</h1></header><form onSubmit={loginAdmin} className="login-card"><h2>Admin Login</h2><input placeholder="Admin username" value={login.username} onChange={(event) => setLogin({ ...login, username: event.target.value })} required /><input type="password" placeholder="Admin password" value={login.password} onChange={(event) => setLogin({ ...login, password: event.target.value })} required /><button type="submit">Sign in</button></form></main>
  );

  return (
    <main className="admin-products">
      <Seo title="Community Moderation" path="/admin/community" noindex />
      <header className="admin-header"><div><h1>Community Moderation</h1><Link className="admin-nav-link" to="/admin">Products</Link></div><button type="button" onClick={() => { localStorage.removeItem('adminAuth'); setAuth(''); }}>Logout</button></header>
      {status && <p>{status}</p>}
      <button type="button" onClick={loadReports}>Refresh reports</button>
      <div className="community-admin-list">
        {reports.map((report) => (
          <article key={report.id} className="community-admin-report">
            <h3>{report.reason} · {report.target_type}</h3>
            <p>Reported by {report.reporter_name} · {report.status}</p>
            {report.details && <p>{report.details}</p>}
            <pre>{report.target ? (report.target.comment || report.target.content || 'No text content') : 'Content no longer exists'}</pre>
            <div className="community-admin-actions"><button type="button" onClick={() => moderate(report, 'hide')}>Hide</button><button type="button" onClick={() => moderate(report, 'restore')}>Restore</button>{report.status === 'pending' && <><button type="button" onClick={() => resolve(report, 'resolved')}>Resolve</button><button type="button" onClick={() => resolve(report, 'dismissed')}>Dismiss</button></>}</div>
          </article>
        ))}
        {!reports.length && <p>No community reports.</p>}
      </div>
    </main>
  );
};

export default AdminCommunity;
